import apiService from './api'

/**
 * API сервис для работы с магазином скинов
 */
const marketApi = {
  /**
   * Получение рандомных скинов и фильтров (первоначальная загрузка)
   * Endpoint: GET /api/market/
   * @returns {Promise<Object>} Объект с found (массив скинов) и filter (объект фильтров)
   */
  getInitialData: async () => {
    try {
      console.log('🛒 Загрузка начальных данных магазина...')
      const response = await apiService.makeRequest('/api/market/', {
        method: 'GET',
      })
      
      console.log('✅ Данные магазина загружены:', response)
      
      return {
        found: response?.found || [],
        filter: response?.filter || {},
      }
    } catch (error) {
      console.error('❌ Ошибка загрузки данных магазина:', error)
      throw error
    }
  },

  /**
   * Применение фильтров для поиска скинов
   * Endpoint: POST /api/market/
   * @param {Object} filters - Объект с фильтрами
   * @returns {Promise<Array>} Массив найденных скинов
   */
  applyFilters: async (filters) => {
    try {
      console.log('🔍 Применение фильтров:', filters)
      const response = await apiService.makeRequest('/api/market/', {
        method: 'POST',
        body: JSON.stringify(filters),
      })
      
      console.log('✅ Результаты поиска получены:', response)
      
      return response?.found || []
    } catch (error) {
      console.error('❌ Ошибка применения фильтров:', error)
      throw error
    }
  },

  /**
   * Покупка скина в магазине
   * Endpoint: POST /api/market/buy/
   * @param {string} skinName - Название скина для покупки
   * @returns {Promise<Object>} Результат покупки с данными купленного скина
   */
  buySkin: async (skinName) => {
    try {
      console.log('💰 Покупка скина:', skinName)
      const response = await apiService.makeRequest('/api/market/buy/', {
        method: 'POST',
        body: JSON.stringify({ name: skinName }),
      })
      
      // Проверяем наличие ошибки в ответе
      if (response?.error) {
        console.error('❌ Ошибка от сервера:', response.error)
        throw new Error(response.error)
      }
      
      console.log('✅ Скин куплен:', response)
      
      // API возвращает { market_buy: {...}, me: {...} }
      return {
        purchasedSkin: response?.market_buy || null,
        user: response?.me || null,
      }
    } catch (error) {
      console.error('❌ Ошибка покупки скина:', error)
      throw error
    }
  },
}

export default marketApi
